/******************************************************************************
 * This file was generated by ZenStack CLI.
 ******************************************************************************/

/* eslint-disable */
// @ts-nocheck

import { z } from 'zod';
const baseSchema = z.object({
    createdAt: z.coerce.date().default(() => new Date()),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    eventType: z.string(),
    messageId: z.string().nullish(),
    webhookData: z.any().nullish(),
    signatureValid: z.boolean(),
    signatureReceived: z.string().nullish(),
    signatureExpected: z.string().nullish(),
    processedAt: z.coerce.date().default(() => new Date()),
}
).strict();
const baseSchemaWithoutDefaults = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    eventType: z.string(),
    messageId: z.string().nullish(),
    webhookData: z.any().nullish(),
    signatureValid: z.boolean(),
    signatureReceived: z.string().nullish(),
    signatureExpected: z.string().nullish(),
    processedAt: z.coerce.date(),
}
).strict();

/**
 * `ResendWebhookLog` schema excluding foreign keys and relations.
 */
export const ResendWebhookLogScalarSchema = baseSchema;


/**
 * `ResendWebhookLog` schema including all fields (scalar, foreign key, and relations) and validations.
 */
export const ResendWebhookLogSchema = ResendWebhookLogScalarSchema;


/**
 * Schema used for validating Prisma create input. For internal use only.
 * @private
 */
export const ResendWebhookLogPrismaCreateSchema = baseSchemaWithoutDefaults.partial().passthrough();


/**
 * Schema used for validating Prisma update input. For internal use only.
 * @private
 */
export const ResendWebhookLogPrismaUpdateSchema = z.object({
    createdAt: z.coerce.date(),
    createdById: z.string().optional(),
    updatedAt: z.coerce.date(),
    updatedById: z.string().nullish(),
    deletedAt: z.coerce.date().nullish(),
    deletedById: z.string().nullish(),
    id: z.string(),
    eventType: z.string(),
    messageId: z.string().nullish(),
    webhookData: z.any().nullish(),
    signatureValid: z.boolean(),
    signatureReceived: z.string().nullish(),
    signatureExpected: z.string().nullish(),
    processedAt: z.coerce.date()
}).partial().passthrough();


/**
 * `ResendWebhookLog` schema for create operations excluding foreign keys and relations.
 */
export const ResendWebhookLogCreateScalarSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, processedAt: true
});


/**
 * `ResendWebhookLog` schema for create operations including scalar fields, foreign key fields, and validations.
 */
export const ResendWebhookLogCreateSchema = baseSchemaWithoutDefaults.partial({
    createdAt: true, createdById: true, updatedAt: true, updatedById: true, id: true, processedAt: true
});


/**
 * `ResendWebhookLog` schema for update operations excluding foreign keys and relations.
 */
export const ResendWebhookLogUpdateScalarSchema = baseSchemaWithoutDefaults.partial();


/**
 * `ResendWebhookLog` schema for update operations including scalar fields, foreign key fields, and validations.
 */
export const ResendWebhookLogUpdateSchema = ResendWebhookLogUpdateScalarSchema;

